import React from 'react';
import { Box, Typography } from '@mui/material';

const InvoiceStats = ({ invoiceStats }) => {
  return (
    <Box sx={{ 
      border: '1px solid #24e4ff',
      borderRadius: '10px',
      padding: '15px',
      marginBottom: '20px'
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <Typography sx={{ color: '#24e4ff' }}>
          Current Total Value: ${invoiceStats.currentTotal.toFixed(2)}
        </Typography>
        <Typography sx={{ color: '#24e4ff' }}>
          Whole Units: {invoiceStats.wholeUnits}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography sx={{ color: '#24e4ff' }}>
            Average Per Unit (w/o aftermarkets): ${invoiceStats.averagePerUnit.toFixed(2)}
          </Typography>
          <Typography sx={{ color: '#24e4ff' }}>
            Average Per Unit (w/ aftermarkets): ${(invoiceStats.averagePerUnitWithAftermarkets || 0).toFixed(2)}
          </Typography>
        </Box>
        <Typography sx={{ color: '#24e4ff' }}>
          Half Units: {invoiceStats.halfUnits}
        </Typography>
        <Typography sx={{ color: '#24e4ff' }}>
          Total Units: {invoiceStats.totalUnits}
        </Typography>
      </Box>
    </Box>
  );
};

export default InvoiceStats; 